/*
 *
 * File: PassengerAcceptBookingDetailsScreen.js
 *
 * Purpose: Passenger accept booking details screen in passengers protected area.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  04.05.2023
 * Modified: 14.05.2023
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { React, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getUserRegistrationData } from "../../utils/utils";
import {
  getUserFromLocalStorage,
  getPassengerDataFromLocalStorage,
} from "../../utils/localStorage";

///--------------------------------------------------------------------
//--- Variable declarations -------------------------------------------
//---------------------------------------------------------------------
const URL_GOOGLE_MAPS = "http://www.google.com/maps/search/?api=1&query=";

let userRegistrationDataObj = null;
//---End component variable declarations ------------------------------

/**
 * Implementation of passenger selected booking details 
 * screen component.
 *
 * @param {*} props
 * @returns JSX-HTML-DOM
 */
const PassengerAcceptBookingDetailsScreen = (props) => {
  const { t, i18n } = useTranslation("common");
  const userData = props.userData;
  const username = getUserFromLocalStorage();
  const passengerData = getPassengerDataFromLocalStorage();

  //--------------------------------------------------------------------
  // Component states
  //--------------------------------------------------------------------

  //--- End states -----------------------------------------------------

  userRegistrationDataObj = getUserRegistrationData(userData);

  //--------------------------------------------------------------------
  //--- Will be called after "first" rendering! ------------------------
  //--------------------------------------------------------------------
  useEffect(() => {}, []);

  //--------------------------------------------------------------------
  //--- Returns JSX code for "PassengerAcceptBookingDetailsScreen" -----
  //--------------------------------------------------------------------
  return (
    <>
      <div
        id="jump-start"
        className="grid p-fluid"
        style={{ paddingLeft: "20px", paddingRight: "20px", marginTop: "30px" }}
      >
        <div className="col-12 md:col-12">
          <div className="text-900 font-medium text-900 text-xl mb-3">
            {t("screentext.screen-text-passenger-booking-details-header")}
          </div>
        </div>
      </div>
      <div style={{ height: "100px" }}>
        <p>{""}</p>
      </div>
    </>
  );
};

export default PassengerAcceptBookingDetailsScreen;
